var React = require('react');

function Writer (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Document"),React.createElement("g",{"fill":"#fff","className":"nc-icon-wrapper","key":1},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.97 3.344a13.006 13.006 0 0 0-5.94 0A7.63 7.63 0 0 0 3.344 9.03a13.006 13.006 0 0 0 0 5.94 7.63 7.63 0 0 0 5.686 5.686c1.953.459 3.987.459 5.94 0a7.63 7.63 0 0 0 5.686-5.686 13.006 13.006 0 0 0 0-5.94 7.63 7.63 0 0 0-5.686-5.686zM8.554 9.128c0-.317.257-.574.574-.574h3.83a.574.574 0 0 1 0 1.148h-3.83a.574.574 0 0 1-.574-.574zm0 2.872c0-.317.257-.574.574-.574h5.744a.574.574 0 0 1 0 1.148H9.128A.574.574 0 0 1 8.554 12zm0 2.872c0-.317.257-.575.574-.575H12a.574.574 0 1 1 0 1.15H9.128a.574.574 0 0 1-.574-.575z","fill":"#fff"}))]);
}

Writer.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Writer;

Writer.default = Writer;
